<template>
    <HeaderNav :is_dialogpage="false" :routername="this.$route.name" :addoredirtname="'0'"></HeaderNav>
    <div id="orderpage">
       <div class="serchbox">
            <div class="serch_form">
                        <div class="serch_item">
                           <label>订单编号：</label>
                           <input type="text" placeholder="请输入订单编号" v-model="queryParams.orderNo" @keyup.enter="handleSearch">
                        </div>
                        <div class="serch_item">
                           <label>查询条件：</label>
                           <select v-model="queryParams.queryType">
                              <option value="0">全部</option>
                              <option v-for="item in queryTypeList" :key="item.id" :value="item.id">{{ item.name }}</option>
                           </select>
                        </div>
                        <div class="serch_item">
                           <label>起始日期：</label>
                           <input type="date" v-model="queryParams.startDate" @change="handleSearch">
                        </div>
                        <div class="serch_item">
                           <label>结束日期：</label>
                           <input type="date" v-model="queryParams.endDate" @change="handleSearch">
                        </div>
             </div>
            <div class="serch_btn">
               <a href="javascript:void(0)" class="btn-search" @click="handleSearch">查询</a>
               <a href="javascript:void(0)" class="btn-reset" @click="handleReset">重置</a>
            </div>
       </div>

       <div class="tablelist">
          <div class="content">
                     <div class="tablebox">
                        <!-- 表头 -->
                        <div class="table-header">
                           <div class="th-col th-order">订单信息</div>
                           <div class="th-col th-customer">客户信息</div>
                           <div class="th-col th-room">房间信息</div>
                           <div class="th-col th-date">入住/离店</div>
                           <div class="th-col th-amount">金额</div>
                           <div class="th-col th-status">状态</div>
                           <div class="th-col th-action">操作</div>
                        </div>
                        <!-- 数据行 -->
                        <div class="table-row" v-for="item in orderList" :key="item.orderId">
                           <div class="td-col td-order">
                              <div class="order-no">{{ item.orderNo }}</div>
                              <div class="order-time">{{ item.createTime }}</div>
                           </div>
                           <div class="td-col td-customer">
                              <div class="customer-name">{{ getItemContact(item, 'telName') }}</div>
                              <div class="customer-phone">{{ getItemContact(item, 'telNo') }}</div>
                           </div>
                           <div class="td-col td-room">
                              <div class="room-name">{{ getItemField(item, 'produtName') }}</div>
                              <div class="room-type">{{ getItemField(item, 'produtBedDesc') }}</div>
                           </div>
                           <div class="td-col td-date">
                              <div class="date-in">入住：{{ getItemField(item, 'startTime') }}</div>
                              <div class="date-out">离店：{{ getItemField(item, 'endTime') }}</div>
                           </div>
                           <div class="td-col td-amount">
                              <div class="amount">￥<font>{{ formatAmount(item.orderAmount) }}</font></div>
                              <div class="pay-amount" v-if="item.payAmount">实付：￥{{ formatAmount(item.payAmount) }}</div>
                           </div>
                           <div class="td-col td-status">
                              <span class="status-tag" :class="getStatusClass(item.orderStatus)">{{ item.orderStatusName }}</span>
                           </div>
                           <div class="td-col td-action">
                              <a href="javascript:void(0)" class="btn-select" @click="showOrderDetail(item)">查看</a>
                              <a href="javascript:void(0)" v-if="item.orderStatus == 1" class="btn-confirm" @click="handleConfirmOrder(item.orderId)">确认</a>
                              <a href="javascript:void(0)" v-if="item.orderStatus == 6" class="btn-checkin" @click="handleCheckinOrder(item.orderId)">入住</a>
                              <!-- <a href="javascript:void(0)" v-if="item.orderStatus == 2" class="btn-checkout" @click="handleCheckoutOrder(item.orderId)">退房</a> -->
                              <a href="javascript:void(0)" v-if="item.orderStatus == 1" class="btn-cancel" @click="handleCancelOrder(item)">取消</a>
                           </div>
                        </div>
                        <div class="no_date" v-if="orderList.length == 0">
                           暂无数据
                        </div>
                     </div> 
             </div>
              <div class="footer" v-if="pagesTotal > 1">
                  <div class="pagebtn">
                     <a href="javascript:void(0)" @click="prepage()" class="prebtn">上一页</a>
                     <a href="javascript:void(0)" 
                        v-for="item in pagebtnList" 
                        :key="item"
                        @click="pageselect(item)" 
                        :class="{'active_page': pageNum == item, 'is_sheng': item == '...'}">
                        {{ item }}
                     </a>
                     <a href="javascript:void(0)" @click="nextpage()" class="nextbtn">下一页</a>
                  </div>
             </div>
          </div>
       </div>

    <!-- 订单详情弹窗 -->
    <div class="order-detail-mask" v-if="detailShow" @click.self="closeDetail">
        <div class="order-detail-box">
            <div class="detail-header">
                <span>订单详情</span>
                <a href="javascript:void(0)" @click="closeDetail">&times;</a>
            </div>
            <div class="detail-content" v-if="currentOrder">
                <div class="detail-row">
                    <label>订单编号：</label><span>{{ currentOrder.orderNo }}</span>
                </div>
                <div class="detail-row">
                    <label>订单状态：</label><span :class="getStatusClass(currentOrder.orderStatus)">{{ currentOrder.orderStatusName }}</span>
                </div>
                <div class="detail-row">
                    <label>下单时间：</label><span>{{ currentOrder.createTime }}</span>
                </div>
                <div class="detail-row">
                    <label>支付时间：</label><span>{{ currentOrder.payTime || '-' }}</span>
                </div>
                <div class="detail-row">
                    <label>订单金额：</label><span class="money-text">￥{{ formatAmount(currentOrder.orderAmount) }}</span>
                </div>
                <div class="detail-row" v-if="currentOrder.payAmount">
                    <label>实付金额：</label><span class="money-text">￥{{ formatAmount(currentOrder.payAmount) }}</span>
                </div>
                <div class="detail-row" v-if="currentOrder.refundAmount">
                    <label>已退款：</label><span class="refund-text">￥{{ formatAmount(currentOrder.refundAmount) }}</span>
                </div>
                <!-- 订单明细 -->
                <div class="detail-divider">订单明细</div>
                <div class="detail-item-box" v-for="(goods, idx) in currentOrder.orderItemList" :key="goods.itemId">
                    <div class="goods-header">
                        <span class="goods-index">明细{{ idx + 1 }}</span>
                        <span class="goods-name">{{ goods.produtName }}</span>
                    </div>
                    <div class="detail-row">
                        <label>房间类型：</label><span>{{ goods.produtTypeName }}</span>
                    </div>

                    <div class="detail-row">
                        <label>联系人：</label><span>{{ goods.telName }}</span>
                    </div>
                    <div class="detail-row">
                        <label>联系电话：</label><span>{{ goods.telNo }}</span>
                    </div>
                    <div class="detail-row">
                        <label>入住日期：</label><span>{{ goods.startTime }}</span>
                    </div>
                    <div class="detail-row">
                        <label>离店日期：</label><span>{{ goods.endTime }}</span>
                    </div>
                    <div class="detail-row">
                        <label>入住天数：</label><span>{{ goods.totalDay }}天</span>
                    </div>
                    <div class="detail-row">
                        <label>单价：</label><span>￥{{ formatAmount(goods.produtPrice) }}</span>
                    </div>
                    <div class="detail-row">
                        <label>数量：</label><span>{{ goods.quantity }}</span>
                    </div>
                    <div class="detail-row">
                        <label>小计：</label><span class="money-text">￥{{ formatAmount(goods.totalPrice) }}</span>
                    </div>
                    <div class="detail-row" v-if="goods.produtBedDesc">
                        <label>床型：</label><span>{{ goods.produtBedDesc }}</span>
                    </div>
                    <div class="detail-row" v-if="goods.produtFloor">
                        <label>楼层：</label><span>{{ goods.produtFloor }}</span>
                    </div>
                    <div class="detail-row" v-if="goods.produtArea">
                        <label>面积：</label><span>{{ goods.produtArea }}m&sup2;</span>
                    </div>
                    <div class="detail-row" v-if="goods.description">
                        <label>描述：</label><span>{{ goods.description }}</span>
                    </div>
                </div>
                <!-- 退款记录 -->
                <div class="detail-divider" v-if="currentOrder.refundList && currentOrder.refundList.length > 0">退款记录</div>
                <div class="detail-item-box" v-for="(refund, ridx) in currentOrder.refundList" :key="refund.refundId">
                    <div class="goods-header">
                        <span class="goods-index">退款{{ ridx + 1 }}</span>
                        <span :class="getRefundStatusClass(refund.refundStatus)">{{ refund.refundStatusDesc }}</span>
                    </div>
                    <div class="detail-row">
                        <label>退款金额：</label><span class="refund-text">￥{{ formatAmount(refund.refundAmount) }}</span>
                    </div>
                    <div class="detail-row" v-if="refund.refundReason">
                        <label>退款原因：</label><span>{{ refund.refundReason }}</span>
                    </div>
                    <div class="detail-row">
                        <label>申请时间：</label><span>{{ refund.createTime }}</span>
                    </div>
                    <div class="detail-row" v-if="refund.successTime">
                        <label>成功时间：</label><span>{{ refund.successTime }}</span>
                    </div>
                </div>
            </div>
            <div class="detail-btns">
                <a href="javascript:void(0)" class="detail-cancel" @click="closeDetail">关闭</a>
            </div>
        </div>
    </div>

 </template>

 <script>
 import { ElMessage, ElMessageBox } from 'element-plus';
 import HeaderNav from '../common/HeaderNav.vue';
 import { selectOrderListPage, confirmOrder, checkinOrder, checkoutOrder, cancelOrder, findMenuContrByMenuId } from "@/tools/Api";

 export default {
    name: "OrderManager",
    components: {
       HeaderNav
    },
    data() {
       return {
          myMenuCode: 4,
          myContrArr: [],

          orderList: [],

          // 分页参数
          pageNum: 1,
          pageSize: 10,
          pagesTotal: 0,
          total: 0,
          pagebtnList: [],

          // 搜索参数
          queryParams: {
             orderNo: '',
             queryType: '0',
             startDate: '',
             endDate: ''
          },

          // 查询条件类型
          queryTypeList: [
              { id: 1, name: "待确认" },
              { id: 2, name: "待入住" },
              { id: 4, name: "已完成" },
              { id: 5, name: "退款" }
          ],

          // 订单详情
          detailShow: false,
          currentOrder: null
       }
    },
    mounted() {
       this.btnListfind();
       this.getOrderList();
    },
    methods: {
       // 获取权限按钮
       btnListfind() {
          findMenuContrByMenuId(this.myMenuCode).then(res => {
             if (res.status == 0) {
                this.myContrArr = res.data;
             }
          }).catch(error => {
             console.log(error);
          });
       },

       // 获取订单列表
       getOrderList() {
          const params = {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
              ...this.queryParams
          };

          selectOrderListPage(params).then(res => {
              if (res.status == 0) {
                 this.orderList = res.data.list;
                 this.pageNum = res.data.pageNum;
                 this.pagesTotal = res.data.pages;
                 this.total = res.data.total;
                 this.pageshowbtn();
              }
          }).catch(err => {
             ElMessage({ message: "请求失败！", type: 'error', duration: 1500 });
          });
       },

       // 搜索
       handleSearch() {
          this.pageNum = 1;
          this.getOrderList();
       },

       // 重置
       handleReset() {
          this.queryParams = {
             orderNo: '',
             queryType: '0',
             startDate: '',
             endDate: ''
          };
          this.handleSearch();
       },

       // 查看订单详情
       showOrderDetail(item) {
          this.currentOrder = item;
          this.detailShow = true;
       },

       closeDetail() {
          this.detailShow = false;
          this.currentOrder = null;
       },

       // 确认订单
       handleConfirmOrder(id) {
          ElMessageBox.confirm('确认该订单？', '提示', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
          }).then(() => {
             confirmOrder(id).then(res => {
                if (res.status == 0) {
                   ElMessage({ message: "操作成功！", type: 'success', duration: 1500 });
                   this.getOrderList();
                } else {
                   ElMessage({ message: res.msg || "操作失败", type: 'error', duration: 1500 });
                }
             }).catch(error => {
                ElMessage({ message: "请求失败！", type: 'error', duration: 1500 });
             });
          }).catch(() => {});
       },

       // 入住
       handleCheckinOrder(id) {
          ElMessageBox.confirm('确认办理入住？', '提示', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
          }).then(() => {
             checkinOrder(id).then(res => {
                if (res.status == 0) {
                   ElMessage({ message: "操作成功！", type: 'success', duration: 1500 });
                   this.getOrderList();
                } else {
                   ElMessage({ message: res.msg || "操作失败", type: 'error', duration: 1500 });
                }
             }).catch(error => {
                ElMessage({ message: "请求失败！", type: 'error', duration: 1500 });
             });
          }).catch(() => {});
       },

       // 退房
       handleCheckoutOrder(id) {
          ElMessageBox.confirm('确认办理退房？', '提示', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             type: 'warning'
          }).then(() => {
             checkoutOrder(id).then(res => {
                if (res.status == 0) {
                   ElMessage({ message: "操作成功！", type: 'success', duration: 1500 });
                   this.getOrderList();
                } else {
                   ElMessage({ message: res.msg || "操作失败", type: 'error', duration: 1500 });
                }
             }).catch(error => {
                ElMessage({ message: "请求失败！", type: 'error', duration: 1500 });
             });
          }).catch(() => {});
       },

       // 取消订单（需填写取消原因，后端仅允许待确认状态取消并触发退款）
       handleCancelOrder(item) {
          ElMessageBox.prompt('取消后订单将进入退款流程，请输入取消原因', '取消订单', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             inputPlaceholder: '请输入取消原因',
             inputType: 'textarea',
             inputValidator: (value) => {
                if (!value || !value.trim()) return '取消原因不能为空';
                return true;
             }
          }).then(({ value }) => {
             cancelOrder({
                orderNo: item.orderNo,
                cancelReason: value.trim()
             }).then(res => {
                if (res.status == 0) {
                   ElMessage({ message: "操作成功！", type: 'success', duration: 1500 });
                   this.getOrderList();
                } else {
                   ElMessage({ message: res.msg || "操作失败", type: 'error', duration: 1500 });
                }
             }).catch(() => {
                ElMessage({ message: "请求失败！", type: 'error', duration: 1500 });
             });
          }).catch(() => {});
       },

       // 分转元
       formatAmount(amount) {
          if (amount === null || amount === undefined || amount === '') return '0.00';
          return (amount / 100).toFixed(2);
       },

       // 从 orderItemList 获取第一个明细的联系人字段
       getItemContact(item, field) {
          if (item.orderItemList && item.orderItemList.length > 0) {
             return item.orderItemList[0][field] || '-';
          }
          return '-';
       },

       // 从 orderItemList 获取第一个明细的字段
       getItemField(item, field) {
          if (item.orderItemList && item.orderItemList.length > 0) {
             return item.orderItemList[0][field] || '-';
          }
          return '-';
       },

       // 获取状态样式class
       getStatusClass(status) {
          switch (status) {
             case 0: return "status-pending";
             case 1: return "status-wait";
             case 2: return "status-done";
             case 3: return "status-refunding";
             case 4: return "status-refunded";
             case 5: return "status-cancel";
             case 6: return "status-checkin";
             case 7: return "status-refund-err";
             case 8: return "status-refund-close";
             default: return "";
          }
       },

       // 退款状态样式
       getRefundStatusClass(status) {
          switch (status) {
             case 0: return "status-refunding";
             case 1: return "status-refunded";
             case 2: return "status-refund-err";
             case 3: return "status-refund-close";
             default: return "";
          }
       },

       // 分页
       pageshowbtn() {
          this.pagebtnList = [];
          if (this.pagesTotal < 7) {
             for (var i = 0; i < this.pagesTotal; i++) {
                this.pagebtnList.push(i + 1);
             }
          } else {
             if (this.pageNum < 5) {
                this.pagebtnList = [1, 2, 3, 4, 5, '...', this.pagesTotal];
             } else if (this.pageNum > this.pagesTotal - 5) {
                this.pagebtnList = [1, '...', this.pagesTotal - 4, this.pagesTotal - 3, this.pagesTotal - 2, this.pagesTotal - 1, this.pagesTotal];
             } else {
                this.pagebtnList = [1, '...', this.pageNum - 1, this.pageNum, this.pageNum + 1, '...', this.pagesTotal];
             }
          }
       },

       pageselect(pgn) {
          if (pgn == "...") return;
          this.pageNum = pgn;
          this.getOrderList();
       },

       nextpage() {
          if (this.pageNum != this.pagesTotal) {
             this.pageNum += 1;
          }
          this.getOrderList();
       },

       prepage() {
          if (this.pageNum != 1) {
             this.pageNum -= 1;
          }
          this.getOrderList();
       }
    }
 }
 </script>

 <style scoped>
 /* 页面主容器 */
 #orderpage {
    width: 100%;
    height: calc(100% - 40px);
    float: left;
    padding: 30px 50px;
    overflow-y: auto;
 }

 /* 搜索区域 */
 #orderpage .serchbox {
    width: 100%;
    height: auto;
    float: left;
    background-color: #f9f9f9;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    padding: 15px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
 }
 #orderpage .serch_form {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
 }
 #orderpage .serch_item {
    display: flex;
    align-items: center;
 }
 #orderpage .serch_item label {
    font-size: 14px;
    color: #606266;
    margin-right: 8px;
    white-space: nowrap;
 }
 #orderpage .serch_item input,
 #orderpage .serch_item select {
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    outline: none;
    font-size: 14px;
    color: #606266;
    min-width: 160px;
    transition: border-color 0.2s;
 }
 #orderpage .serch_item input:focus,
 #orderpage .serch_item select:focus {
    border-color: #e57834;
 }
 #orderpage .serch_btn {
    display: flex;
    gap: 10px;
    flex-shrink: 0;
 }
 #orderpage .serch_btn a {
    text-decoration: none;
    height: 32px;
    line-height: 32px;
    padding: 0 15px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s;
    display: inline-block;
    text-align: center;
 }
 #orderpage .serch_btn .btn-search {
    background-color: #e57834;
    color: #fff;
    border: 1px solid #e57834;
 }
 #orderpage .serch_btn .btn-search:hover {
    background-color: #f08a42;
 }
 #orderpage .serch_btn .btn-reset {
    background-color: #fff;
    color: #606266;
    border: 1px solid #dcdfe6;
 }
 #orderpage .serch_btn .btn-reset:hover {
    color: #e57834;
    border-color: #e57834;
    background-color: #fef0e6;
 }

 /* 订单统计 - 已移除 */

 /* 表格列表 */
 #orderpage .tablelist {
    width: 100%;
    height: auto;
    float: left;
    margin-top: 15px;
 }
 #orderpage .tablelist .content {
    width: 100%;
    height: auto;
    float: left;
    margin-bottom: 5px;
 }
 #orderpage .tablelist .content .tablebox {
    width: 100%;
    height: auto;
    float: left;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    overflow: hidden;
 }

 /* 表头 */
 #orderpage .tablebox .table-header {
    width: 100%;
    height: 45px;
    float: left;
    background-color: #f5f5f5;
    border-bottom: 1px solid #eaeaea;
    display: flex;
    align-items: center;
 }
 #orderpage .tablebox .table-header .th-col {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    padding: 0 10px;
 }

 /* 数据行 */
 #orderpage .tablebox .table-row {
    width: 100%;
    float: left;
    border-bottom: 1px solid #eaeaea;
    display: flex;
    align-items: center;
    padding: 12px 0;
    transition: background-color 0.2s;
 }
 #orderpage .tablebox .table-row:last-child {
    border-bottom: none;
 }
 #orderpage .tablebox .table-row:hover {
    background-color: #fef8f4;
 }

 /* 列宽分配 */
 #orderpage .tablebox .th-col,
 #orderpage .tablebox .td-col {
    flex: 1;
    min-width: 0;
 }
 #orderpage .tablebox .th-order,
 #orderpage .tablebox .td-order { flex: 1.5; }
 #orderpage .tablebox .th-customer,
 #orderpage .tablebox .td-customer { flex: 1.2; }
 #orderpage .tablebox .th-room,
 #orderpage .tablebox .td-room { flex: 1.2; }
 #orderpage .tablebox .th-date,
 #orderpage .tablebox .td-date { flex: 1.3; }
 #orderpage .tablebox .th-amount,
 #orderpage .tablebox .td-amount { flex: 1; }
 #orderpage .tablebox .th-status,
 #orderpage .tablebox .td-status { flex: 0.8; text-align: center; }
 #orderpage .tablebox .th-action,
 #orderpage .tablebox .td-action { flex: 1.8; }

 /* 单元格内容 */
 #orderpage .tablebox .td-col {
    padding: 0 10px;
    font-size: 13px;
    color: #606266;
    line-height: 22px;
 }
 #orderpage .tablebox .td-col .order-no {
    font-size: 14px;
    color: #333;
    font-weight: bold;
 }
 #orderpage .tablebox .td-col .order-time {
    font-size: 12px;
    color: #999;
 }
 #orderpage .tablebox .td-col .customer-name {
    color: #333;
 }
 #orderpage .tablebox .td-col .customer-phone {
    font-size: 12px;
    color: #999;
 }
 #orderpage .tablebox .td-col .amount font {
    color: #e0402a;
    font-size: 16px;
    font-weight: bold;
 }
 #orderpage .tablebox .td-col .pay-amount {
    font-size: 12px;
    color: #999;
 }

 /* 状态标签 */
 #orderpage .tablebox .td-col .status-tag {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 3px;
    font-size: 12px;
 }
 .status-pending { background-color: #f0f0f0; color: #999; }
 .status-wait { background-color: #fdf6ec; color: #e6a23c; }
 .status-done { background-color: #f0f9eb; color: #12ab04; }
 .status-refunding { background-color: #fef0f0; color: #f56c6c; }
 .status-refunded { background-color: #fef0f0; color: #e0402a; }
 .status-cancel { background-color: #f4f4f4; color: #aaa; }
 .status-checkin { background-color: #ecf5ff; color: #409eff; }
 .status-refund-err { background-color: #fff3e0; color: #e6a23c; }
 .status-refund-close { background-color: #f4f4f4; color: #999; }

 /* 操作按钮 */
 #orderpage .tablebox .td-action a {
    text-decoration: none;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    height: 26px;
    line-height: 26px;
    padding: 0 10px;
    margin: 2px 3px;
    text-align: center;
    border-radius: 3px;
    cursor: pointer;
 }
 #orderpage .tablebox .td-action .btn-select {
    background-color: #e57834;
 }
 #orderpage .tablebox .td-action .btn-select:hover {
    background-color: #f08a42;
 }
 #orderpage .tablebox .td-action .btn-confirm {
    background-color: #409eff;
 }
 #orderpage .tablebox .td-action .btn-confirm:hover {
    background-color: #66b1ff;
 }
 #orderpage .tablebox .td-action .btn-checkin {
    background-color: #67c23a;
 }
 #orderpage .tablebox .td-action .btn-checkin:hover {
    background-color: #85ce61;
 }
 #orderpage .tablebox .td-action .btn-checkout {
    background-color: #12ab04;
 }
 #orderpage .tablebox .td-action .btn-checkout:hover {
    background-color: #17cf07;
 }
 #orderpage .tablebox .td-action .btn-cancel {
    background-color: #f56c6c;
 }
 #orderpage .tablebox .td-action .btn-cancel:hover {
    background-color: #f78989;
 }

 /* 暂无数据 */
 #orderpage .tablebox .no_date {
    width: 100%;
    height: 100px;
    line-height: 100px;
    text-align: center;
    color: #999;
    font-size: 14px;
 }

 /* 分页 */
 #orderpage .tablelist .footer {
    width: 100%;
    height: 40px;
    float: left;
    text-align: center;
    margin-top: 20px;
 }
 #orderpage .tablelist .footer a {
    text-decoration: none;
    color: #5b5858;
    display: inline-block;
    font-size: 14px;
    width: auto;
    min-width: 30px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #ccc;
    margin: 5px 2px;
    background-color: #fff;
 }
 #orderpage .tablelist .footer a.nextbtn,
 #orderpage .tablelist .footer a.prebtn {
    border: none;
    background-color: #e57834;
    color: #fff;
    padding: 0 10px;
 }
 #orderpage .tablelist .footer a.active_page {
    border: none;
    background-color: #d81d1d;
    color: #fff;
 }
 #orderpage .tablelist .footer a.is_sheng {
    border: none;
    background-color: transparent;
 }

 /* 订单详情弹窗 */
 .order-detail-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: rgba(0,0,0,0.6);
 }
 .order-detail-box {
    width: 550px;
    max-height: 80vh;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
 }
 .detail-header {
    width: 100%;
    height: 50px;
    background-color: #e57834;
    border-radius: 10px 10px 0 0;
    position: relative;
 }
 .detail-header span {
    display: block;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
 }
 .detail-header a {
    position: absolute;
    right: 15px;
    top: 0;
    color: #fff;
    font-size: 28px;
    text-decoration: none;
    line-height: 50px;
 }
 .detail-content {
    width: 100%;
    padding: 25px 35px;
    flex: 1;
    overflow-y: auto;
 }
 .detail-row {
    width: 100%;
    min-height: 36px;
    line-height: 36px;
    overflow: hidden;
 }
 .detail-row label {
    width: 100px;
    float: left;
    font-size: 14px;
    color: #888;
    text-align: right;
    margin-right: 10px;
 }
 .detail-row span {
    float: left;
    font-size: 14px;
    color: #333;
 }
 .detail-row .money-text {
    color: #e0402a;
    font-weight: bold;
    font-size: 16px;
 }
 .detail-btns {
    width: 100%;
    text-align: center;
    padding: 0 0 25px;
    flex-shrink: 0;
 }
 .detail-btns a {
    display: inline-block;
    width: 100px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    border-radius: 5px;
    font-size: 15px;
    text-decoration: none;
 }
 .detail-cancel {
    background-color: #ccc;
    color: #555;
 }
 .detail-cancel:hover {
    background-color: #bbb;
 }

 /* 详情弹窗 - 分隔线 */
 .detail-divider {
    width: 100%;
    height: 1px;
    background-color: #eaeaea;
    margin: 15px 0;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    line-height: 30px;
    border-bottom: none;
 }

 /* 明细/退款卡片 */
 .detail-item-box {
    width: 100%;
    padding: 10px 0 5px;
    border-bottom: 1px dashed #eaeaea;
    margin-bottom: 10px;
 }
 .detail-item-box:last-child {
    border-bottom: none;
 }
 .goods-header {
    width: 100%;
    height: 30px;
    line-height: 30px;
    margin-bottom: 5px;
 }
 .goods-index {
    font-size: 13px;
    color: #999;
    margin-right: 10px;
 }
 .goods-name {
    font-size: 14px;
    color: #333;
    font-weight: bold;
 }

 /* 退款金额文字 */
 .detail-row .refund-text {
    color: #f56c6c;
    font-weight: bold;
    font-size: 14px;
 }
 </style>
